<template>
  <card-item
    card="item_user"
    :tabs="tabs"
    v-model="activeTab"
    :id="`${id}${$store.state.user.sections['users'] ? '' : '000030003'}`"
  >
  </card-item>
</template>
<script>
export default {
  methods: {},
  props: ["id"],
  data() {
    return {
      tabs: [
        {
          title: "Информация",
          key: "info",
          component: () => import("./Info"),
        },
        {
          title: "Ограничения сервисов",
          key: "permissions",
          component: () => import("./ServicePermissions"),
        },
      ],
      activeTab: 0,
    };
  },
};
</script>